// src/App.js


import React, { useEffect, useState } from 'react';
import './App.css';
import Main from './components/Main/Main';
import UCP from './components/routes/Other/UCP/UCP';

const getAuthToken = () => localStorage.getItem('token') || sessionStorage.getItem('token');

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => Boolean(getAuthToken()));

  useEffect(() => {
    const syncAuthState = () => {
      setIsLoggedIn(Boolean(getAuthToken()));
    };

    window.addEventListener('storage', syncAuthState);
    window.addEventListener('focus', syncAuthState);
    window.addEventListener('crm:auth-changed', syncAuthState);
    syncAuthState();

    return () => {
      window.removeEventListener('storage', syncAuthState);
      window.removeEventListener('focus', syncAuthState);
      window.removeEventListener('crm:auth-changed', syncAuthState);
    };
  }, []);
  
  return (
      <div className="App">
        <Main />
        <UCP isLoggedIn={isLoggedIn} />
      </div>
  );
}

export default App;
